import v1 from "./v1.js";
import v2 from "./v2.js";
import v3 from "./v3.js";

export default [v1, v2, v3];
